import { Component, inject, Input, OnChanges, SimpleChanges } from '@angular/core'
import { IonicModule } from '@ionic/angular'
import { NgForOf, NgIf } from '@angular/common'
import { FinanceService } from '../../../../services/domain/finance.service'

export type AssistanceEditorFinance = {
  clientSum: number
  assistants: { fullname: string; sum: number }[]
}

@Component({
  selector: 'app-assistance-editor-finance-viewer',
  templateUrl: './assistance-editor-finance-viewer.component.html',
  styleUrls: ['./assistance-editor-finance-viewer.component.scss'],
  standalone: true,
  imports: [IonicModule, NgForOf, NgIf],
})
export class AssistanceEditorFinanceViewerComponent implements OnChanges {
  private financeService = inject(FinanceService)

  @Input() assistanceId: number

  protected finance: AssistanceEditorFinance

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    if (changes.assistanceId) {
      this.finance = await this.financeService.getEditorAssistanceFinancialReportsForAssistance(
        changes.assistanceId.currentValue,
      )
    }
  }
}
